export const localStorageData = {
  googleInfo: localStorage.getItem("gInfo"),
  facebookInfo: localStorage.getItem("fbInfo"),
  walletAddress: localStorage.getItem("address"),
};
